export const ERROR_STATUS_CODES_TO_IGNORE = new Set<number>([401, 404]);
